module.exports = __webpack_public_path__ + "static/media/enact_policies.c44fc862.mp4";